export default "/34887f8f847f5d202a469a9dd4881160882f8c6b/d50cc34e778c6c20c755dccf4a153599.svg";